import { render, staticRenderFns } from "./advancement-icon.vue?vue&type=template&id=527f3970&"
import script from "./advancement-icon.vue?vue&type=script&lang=js&"
export * from "./advancement-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports